<i18n>
{
    "uk": {
        "next": "Наступне зображення (→)",
        "prev": "Попереднє зображення (←)"
    },
    "en": {
        "next": "Next image (→)",
        "prev": "Previous image (←)"
    }
}
</i18n>

<template>
    <div
        class="practice-overlay material-gallery p-0"
        id="material-overlay-gallery"
        @click="clickHandler"
        v-bsl="true"
    >
        <transition :name="transitionName" mode="out-in">
            <div class="gallery-image px-md-5 py-md-2"
                :key="id"
                v-if="image"
            >
                <img
                    v-if="isGif"
                    :src="`${$CDN}/image/original/${image.name}`"
                    alt=""
                >

                <img 
                    v-else-if="useBase64"
                    :src="image.src" 
                    alt=""
                >

                <picture v-else>
                    <source
                        v-if="hasWebp && enableSources"
                        :srcset="`
                            ${$CDN}/image/medium/${image.name}.webp 400w,
                            ${$CDN}/image/standart/${image.name}.webp 1280w,
                            ${$CDN}/image/large/${image.name}.webp 2360w,
                        `"
                        type="image/webp"
                    >

                    <source
                        :srcset="`
                            ${$CDN}/image/medium/${image.name} 400w,
                            ${$CDN}/image/standart/${image.name} 1280w,
                            ${$CDN}/image/large/${image.name} 2360w,
                        `"
                        :type="type"
                    >

                    <img
                        :src="`${$CDN}/image/original/${image.name}`"
                        :srcset="`
                            ${$CDN}/image/medium/${image.name} 400w,
                            ${$CDN}/image/standart/${image.name} 1280w,
                            ${$CDN}/image/large/${image.name} 2360w,
                        `"
                        alt=""
                        @error="errorHandler"
                    >
                </picture>
            </div>
        </transition>


        <button
            v-if="!isFirst"
            @click="prev"
            class="go-prev btn-icon"
            id="material-gal-prev"
            :title="$t('prev')"
        >
            <span class="icon-ic-arrow-simple"></span>
        </button>

        <button
            v-if="!isLast"
            @click="next"
            class="go-next btn-icon"
            id="material-gal-nex"
            :title="$t('next')"
        >
            <span class="icon-ic-arrow-simple"></span>
        </button>
    </div>
</template>

<script>
const allowedTypes = [`image/png`, `image/jpeg`];

export default {
    props: ['image', 'id', 'isFirst', 'isLast', 'useBase64'],

    data () {
        return {
            transitionName: 'gallery-next',
            enableSources: true
        }
    },

    computed: {
        hasWebp () {
            if (this.useBase64) return false;
            if (!allowedTypes.includes(this.type)) return false;
            if (!this.image.width || this.image.height) return true;

            return this.image.width * this.image.height < 21120000; //1920 * 11000
        },

        ext () {
            if (this.useBase64) return null;
            let arr = this.image.name.split('.');
            let ext = arr[arr.length - 1];
            return ext;
        },

        type () {
            if (this.useBase64) return null;
            let type = this.ext == 'jpg' ? 'jpeg' : this.ext;
            return `image/${type}`;
        },

        isGif () {
            return this.ext == 'gif';
        }
    },

    mounted () {
        window.addEventListener('keydown', this.keypress);
    },

    methods: {
        keypress (e) {
            let inputs = ['INPUT', 'TEXTAREA'];
            if (inputs.indexOf(e.target.tagName.toUpperCase()) >= 0) return true;

            if (e.keyCode == 37) return this.prev();
            if (e.keyCode == 39) return this.next();
        },

        next (e) {
            if (e) e.stopPropagation();

            this.transitionName = 'gallery-next';
            this.$emit('next');
            document.getElementById('cases-overlay').scrollTop = 0;

            this.$nextTick(() => {
                this.enableSources = true;
            })
        },

        prev (e) {
            if (e) e.stopPropagation();

            this.transitionName = 'gallery-prev';
            this.$emit('prev');
            document.getElementById('cases-overlay').scrollTop = 0;

            this.$nextTick(() => {
                this.enableSources = true;
            })
        },

        close () {
            this.$modalityStore.closeModal({type: 'overlay', name: 'gallery'});
            this.enableSources = true;
        },

        clickHandler (e) {
            this.close()
        },

        errorHandler (e) {
            this.enableSources = false;
        }
    },

    destroyed () {
        window.removeEventListener('keydown', this.keypress);
    },
}
</script>

<style lang="scss" scoped>
    .gallery-next-enter-active,
    .gallery-prev-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity .25s cubic-bezier(0.39, 0.575, 0.565, 1),
                    transform .25s cubic-bezier(0.39, 0.575, 0.565, 1);
    }

    .gallery-prev-leave-to,
    .gallery-prev-enter,
    .gallery-next-leave-to,
    .gallery-next-enter {
        opacity: 0;
        transition: opacity .25s cubic-bezier(0.47, 0, 0.745, 0.715),
                    transform .25s cubic-bezier(0.47, 0, 0.745, 0.715);
    }



    .gallery-prev-leave-to,
    .gallery-next-enter {
        transform: translateX(50vw);
    }

    .gallery-next-leave-to,
    .gallery-prev-enter {
        transform: translateX(-50vw);
    }

    .overlay-gallery {
        min-height: auto;
        max-width: 1280px;

        position: relative;
        bottom: auto;
        overflow: visible;
        border-radius: 0;

        flex-basis: 1280px;

        padding: 16px 0;
    }

    .btn-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        box-shadow: 0px 0px 0px transparent,
                    0px 0px 0px 1px transparent;
        transition: box-shadow .15s ease;


        &:hover {
            box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.32),
                        0px 0px 0px 1px #fff;
        }
    }
</style>
